/* ============================================================
   BOYA THEME — JavaScript
   Handles: mobile menu, nav scroll shadow, Ajax add-to-cart,
   cart badge live update
   Vanilla JS only — no jQuery dependency
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     NAV — scroll shadow
  ---------------------------------------------------------- */
  /* ----------------------------------------------------------
     BOYA NAV CART BUTTON — open Dwell's cart drawer on click
  ---------------------------------------------------------- */
  function initNavCartButton() {
    var cartBtn = document.querySelector('.boya-nav-cart');
    if (!cartBtn) return;

    cartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var cartDrawer = document.querySelector('cart-drawer-component');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    });
  }

  function initNavScroll() {
    var nav = document.querySelector('.boya-nav');
    if (!nav) return;

    function onScroll() {
      if (window.scrollY > 10) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run on load in case page is already scrolled
  }

  /* ----------------------------------------------------------
     MOBILE MENU — hamburger toggle
  ---------------------------------------------------------- */
  function initMobileMenu() {
    var hamburger = document.querySelector('.boya-nav-hamburger');
    var mobileMenu = document.querySelector('.boya-mobile-menu');
    if (!hamburger || !mobileMenu) return;

    function openMenu() {
      hamburger.classList.add('open');
      mobileMenu.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onOutsideClick);
      document.addEventListener('keydown', onKeyDown);
    }

    function closeMenu() {
      hamburger.classList.remove('open');
      mobileMenu.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onOutsideClick);
      document.removeEventListener('keydown', onKeyDown);
    }

    function toggleMenu() {
      if (mobileMenu.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    }

    function onOutsideClick(e) {
      var nav = document.querySelector('.boya-nav');
      if (nav && !nav.contains(e.target)) {
        closeMenu();
      }
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        closeMenu();
      }
    }

    hamburger.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleMenu();
    });

    // Close menu when a link is clicked
    var mobileLinks = mobileMenu.querySelectorAll('a');
    mobileLinks.forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  /* ----------------------------------------------------------
     CART BADGE — update all badges on the page
  ---------------------------------------------------------- */
  function updateCartBadges(count) {
    var badges = document.querySelectorAll('.boya-nav-cart-badge');
    badges.forEach(function (badge) {
      badge.textContent = count;
      badge.setAttribute('data-count', count);
    });
  }

  /* ----------------------------------------------------------
     AJAX ADD TO CART
     Usage: add data-boya-atc and data-variant-id to any button
     Example:
       <button class="boya-btn-cta-sm"
               data-boya-atc
               data-variant-id="{{ product.variants.first.id }}">
         Add to Cart
       </button>
  ---------------------------------------------------------- */
  function initAjaxCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-boya-atc]');
      if (!btn) return;

      e.preventDefault();

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) {
        console.warn('Boya ATC: No variant ID found on button');
        return;
      }

      var originalText = btn.innerHTML;
      btn.classList.add('boya-btn-adding');
      btn.innerHTML = 'Adding…';

      // Collect Dwell's cart-items-component section IDs
      // so Shopify returns updated cart drawer HTML alongside the cart response
      var cartItemComponents = document.querySelectorAll('cart-items-component[data-section-id]');
      var sectionIds = [];
      cartItemComponents.forEach(function (el) {
        var sid = el.getAttribute('data-section-id');
        if (sid && sectionIds.indexOf(sid) === -1) sectionIds.push(sid);
      });

      // Use FormData so we can append sections (JSON body doesn't support multi-value)
      var formData = new FormData();
      formData.append('id', parseInt(variantId, 10));
      formData.append('quantity', 1);
      if (sectionIds.length > 0) {
        formData.append('sections', sectionIds.join(','));
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || 'Add to cart failed');
            });
          }
          return res.json();
        })
        .then(function (response) {
          var addResponse = response;

          // Fetch /cart.js to get the true total item count
          // /cart/add.js returns quantity of the item added, not total cart count
          return fetch('/cart.js', {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              var totalCount = cart.item_count || 0;

              // Dispatch Dwell's cart:update event with true total count and sections HTML
              var cartAddEvent = new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: 'boya-atc',
                  data: {
                    source: 'boya-atc',
                    itemCount: totalCount,
                    variantId: variantId,
                    sections: addResponse.sections || {}
                  }
                }
              });
              document.dispatchEvent(cartAddEvent);

              // Update Boya nav cart badge with true total
              updateCartBadges(totalCount);

              // Open Dwell's cart drawer
              var cartDrawer = document.querySelector('cart-drawer-component');
              if (cartDrawer && typeof cartDrawer.open === 'function') {
                cartDrawer.open();
              }

              // Visual feedback
              btn.classList.remove('boya-btn-adding');
              btn.classList.add('boya-btn-added');
              btn.innerHTML = 'Added ❖';

              setTimeout(function () {
                btn.classList.remove('boya-btn-added');
                btn.innerHTML = originalText;
              }, 2500);
            });
        })
        .catch(function (err) {
          console.error('Boya ATC Error:', err);
          btn.classList.remove('boya-btn-adding');
          btn.classList.add('boya-btn-error');
          btn.innerHTML = err.message || 'Could not add to cart';

          // Reset button after 3s
          setTimeout(function () {
            btn.classList.remove('boya-btn-error');
            btn.innerHTML = originalText;
          }, 3000);
        });
    });
  }

  /* ----------------------------------------------------------
     PRODUCT FORM — add-to-cart button feedback
     Dwell's product-form-component handles the Ajax submission.
     We show "Adding…" on click and reset on cart:update event
     or after a timeout fallback.
  ---------------------------------------------------------- */
  function initProductFormFeedback() {
    var productForms = document.querySelectorAll('.boya-product-form');
    productForms.forEach(function (form) {
      form.addEventListener('submit', function () {
        var submitBtn = form.querySelector('[type="submit"]');
        if (!submitBtn) return;

        var originalText = submitBtn.innerHTML;
        submitBtn.innerHTML = 'Adding…';
        submitBtn.disabled = true;

        // Reset button when Dwell fires cart:update (success or error)
        function resetBtn() {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
          document.removeEventListener('cart:update', resetBtn);
          clearTimeout(fallbackTimer);
        }

        document.addEventListener('cart:update', resetBtn);

        // Fallback: reset after 4s in case cart:update never fires
        var fallbackTimer = setTimeout(function () {
          resetBtn();
        }, 4000);
      });
    });
  }

  /* ----------------------------------------------------------
     INIT — run everything on DOMContentLoaded
  ---------------------------------------------------------- */
  /* ----------------------------------------------------------
     CART SYNC — keep Boya badge in sync with ALL cart changes
     Listens for Dwell's cart:update event which fires on:
     - Item removal from drawer
     - Quantity changes in drawer
     - Any other cart mutation Dwell handles natively
  ---------------------------------------------------------- */
  function initCartSync() {
    document.addEventListener('cart:update', function (e) {
      // Skip events from our own Ajax ATC — initAjaxCart handles those already
      if (e.detail && e.detail.sourceId === 'boya-atc') return;

      var source = e.detail && e.detail.data && e.detail.data.source;
      var itemCount = e.detail && e.detail.data && e.detail.data.itemCount;

      // cart-items-component (drawer remove/quantity change) sends the true total count
      // All other sources (product-form-component etc.) send qty added, not total
      // So we only trust itemCount directly from cart-items-component
      if (source === 'cart-items-component' && typeof itemCount === 'number') {
        updateCartBadges(itemCount);
        return;
      }

      // For all other sources, fetch /cart.js to get the true total
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) { updateCartBadges(cart.item_count || 0); })
        .catch(function () {});
    });
  }

  /* ----------------------------------------------------------
     BFCACHE — restore correct badge when user navigates back
     Dwell uses sessionStorage for this; we just fetch /cart.js
  ---------------------------------------------------------- */
  function initBfcacheSync() {
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        // Page restored from back-forward cache — badge may be stale
        fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) { updateCartBadges(cart.item_count || 0); })
          .catch(function () {});
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNavScroll();
    initMobileMenu();
    initNavCartButton();
    initAjaxCart();
    initCartSync();
    initBfcacheSync();
    initProductFormFeedback();
  });

})();
